import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/sections/Hero";
import { Marquee } from "@/components/sections/Marquee";
import { Manifesto } from "@/components/sections/Manifesto";
import { Services } from "@/components/sections/Services";
import { Pricing } from "@/components/sections/Pricing";
import { Stats } from "@/components/sections/Stats";
import { Method } from "@/components/sections/Method";
import { Forensics } from "@/components/sections/Forensics";
import { Academy } from "@/components/sections/Academy";
import { ThreatSection } from "@/components/sections/ThreatSection";
import { Contact } from "@/components/sections/Contact";
import { Footer } from "@/components/Footer";

export default function Landing() {
  return (
    <>
      <Navbar />
      <main className="relative z-10">
        <Hero />
        <Marquee />
        <Manifesto />
        <Services />
        <Pricing />
        <Stats />
        <Method />
        <Forensics />
        <Academy />
        <ThreatSection />
        <Contact />
      </main>
      <Footer />
    </>
  );
}
